import React from 'react';
const tags = ['100% Digital', 'Acceso Inmediato', 'En Español', 'Para Todo Nivel'];
export function SolutionSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-192">
      <div className="max-w-4xl mx-auto text-center" data-id="element-193">
        <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white font-bold text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-194">
          🏆 El Sistema más Completo para Entrenadores de Fútbol Juvenil
        </div>

        <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] mb-4 tracking-tight" data-id="element-195">
          FÚTBOL LISTO <span className="text-[#00A650]" data-id="element-196">360™</span>
        </h2>

        <p className="text-[#0A0A0A] text-xl sm:text-2xl font-black mb-6" data-id="element-197">
          6 Volúmenes + 5 Bonos
        </p>

        <p className="text-[#5A5A66] text-base sm:text-lg max-w-2xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-198">
          250 páginas. 6 volúmenes completos. 101 ejercicios técnicos. 5 bonos
          estratégicos. Progresiones completas. Planificación de la temporada.
          Gestión del equipo.{' '}
          <strong className="text-[#0A0A0A]" data-id="element-199">Todo ya está hecho.</strong>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-[#0A0A0A] text-sm sm:text-base font-black mb-10" data-id="element-200">
          <span className="flex items-center gap-2" data-id="element-201">📄 250 páginas</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-202">|</span>
          <span className="flex items-center gap-2" data-id="element-203">⚽ 6 Volúmenes</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-204">|</span>
          <span className="flex items-center gap-2" data-id="element-205">🔥 101 Ejercicios</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-206">|</span>
          <span className="flex items-center gap-2" data-id="element-207">🎯 5 Bonos</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-208">
          {tags.map(tag => <span key={tag} className="bg-[#FAFAFA] border border-[#E5E5EA] text-[#0A0A0A] text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-209">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}